module.exports = "<div [ngClass]=\"{hidden: ! panelVisibility}\" [ngStyle]=\"{'margin-left' : getMarginLeft(mainDiv)}\" #mainDiv class=\"floating-button-panel {{ additionStyleClassName }}\" (mouseover)=\"isVisible = true\" (mouseout)=\"isVisible = false\" (click)=\"isVisible = ! isVisible\">\n    <div>\n        <a *ngIf=\"! buttonType\" (click)=\"gotoCurrentPricing()\">Go to <b>PRICING</b></a>\n        <a *ngIf=\"buttonType\" (click)=\"gotoAllPricings()\">Go to <b>All PRICINGS</b></a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/floating-button/template.html
// module id = 1418
// module chunks = 9